import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { canAccess } from '@ams/shared/module-access';
import { useAuth } from '../auth/AuthContext.js';
import { MODULES } from './modules.js';
import { formatBuildLabel, formatBuildTooltip } from './buildInfo.js';
import './AppShell.css';

export function AppShell(): JSX.Element {
  const { payload, logout } = useAuth();
  const privileges = payload?.privileges ?? [];
  const visibleModules = MODULES.filter((m) => canAccess(m.id, privileges));

  return (
    <div className="app-shell">
      <header className="app-shell-header">
        <div className="app-shell-brand">
          <strong>Aptitude Medical</strong>
          <span>Ops Platform</span>
        </div>
        <nav className="app-shell-modules" aria-label="Primary">
          {visibleModules.map((m) =>
            m.external ? (
              // Separate Vite entry / standalone site — full-page navigation.
              <a key={m.id} href={m.path} className="app-shell-module">
                <span className="app-shell-module-icon" aria-hidden="true">
                  {m.icon}
                </span>
                {m.label}
              </a>
            ) : (
              <NavLink
                key={m.id}
                to={m.path}
                className={({ isActive }) =>
                  isActive ? 'app-shell-module active' : 'app-shell-module'
                }
              >
                <span className="app-shell-module-icon" aria-hidden="true">
                  {m.icon}
                </span>
                {m.label}
              </NavLink>
            ),
          )}
        </nav>
        <div className="app-shell-user">
          <span className="app-shell-build" title={formatBuildTooltip()}>
            {formatBuildLabel()}
          </span>
          <span className="app-shell-user-email">{payload?.user.email ?? ''}</span>
          <button
            type="button"
            className="app-shell-signout"
            onClick={() => {
              void logout();
            }}
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="app-shell-content">
        <Outlet />
      </main>
    </div>
  );
}
